export const SORT_ORDER = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
};
